import { render, staticRenderFns } from "./addShareholderDividends.vue?vue&type=template&id=3690a4b0&scoped=true&"
import script from "./addShareholderDividends.vue?vue&type=script&lang=js&"
export * from "./addShareholderDividends.vue?vue&type=script&lang=js&"
import style0 from "./addShareholderDividends.vue?vue&type=style&index=0&id=3690a4b0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3690a4b0",
  null
  
)

export default component.exports